import styled from "styled-components";

import { colorsPalettes, elevation } from "@similarweb/styles";
import { Box, Flex } from "@similarweb/ui-components/foundations";

export const FilterWrapper = styled(Box)`
    cursor: pointer;
`;

export const NeutralChip = styled(Flex)`
    background-color: ${colorsPalettes.carbon[50]};
    border-radius: 12px;
    padding: 3px 8px;
    cursor: default;
`;

export const FiltersCardsGroup = styled(Flex)`
    flex-wrap: wrap;
    border-radius: 6px;
    overflow: hidden;
    background: ${colorsPalettes.carbon[0]};
    box-shadow: ${elevation.Z1};

    & > *:not(:last-child) {
        border-right: 1px solid ${colorsPalettes.carbon[100]};
    }
`;

export const FiltersCardContainer = styled(Box)`
    display: flex;
    flex: 1 1 220px;
    min-width: 0;
    min-height: 106px;
`;
